import { render } from "./MButton.vue?vue&type=template&id=b97ebcf4&scoped=true"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"

import "./MButton.vue?vue&type=style&index=0&id=b97ebcf4&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97ebcf4"]])

export default __exports__